export default "<p>crm-reportes works!</p>\n"